import ErrorStatePage from './ErrorStatePage';

export default function InternalServerErrorPage() {
    return <ErrorStatePage code="500" title="Erro interno" description="Não foi possível concluir a operação. Tente novamente em alguns instantes." />;
}
